module.exports = __webpack_public_path__ + "static/media/citations.4413437a.png";